import { formatInTimeZone } from 'date-fns-tz';
const getTimezoneAbbr = (timezone) => {
  switch (timezone) {
    case 'Asia/Jakarta':
      return 'WIB';
    case 'Asia/Makassar':
      return 'WITA';
    case 'Asia/Jayapura':
      return 'WIT';
    case 'Asia/Kuala_Lumpur':
      return 'MYT';
    default:
      return formatInTimeZone(new Date(), timezone, 'z');
  }
};

export default getTimezoneAbbr;
